"use strict";
// This file is auto-generated by @hey-api/openapi-ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.postServiceV1 = exports.postContractsV1 = exports.getPresignV1 = exports.getAddressinfoV1 = exports.getBoilerProducts = exports.getGetaddressinfoV1 = exports.postGenericnoncommodityV1 = exports.postSenoV1 = exports.postHeatpumpV1 = exports.postBoilerV1 = exports.postHomebatteryV1 = exports.postProductadviceV1 = exports.postAdviceV1 = exports.postThirdpartyV1 = exports.getValidatePostalCodeHouseScanV1 = exports.postHousescanV1 = exports.postSolarpanelV1 = exports.postInsulationV1 = exports.getCheckV1 = exports.getTimesV1 = exports.getDaysV1 = exports.getSolarpaybackV1 = exports.postGenericFormSubmit = exports.getValidatePostalCodeV1 = void 0;
/**
 * @deprecated
 * Validate a provided postcode and house number using the Cadastre API from Sustainables.
 * @param data The data for the request.
 * @param data.postcode Postcode in Dutch format
 * @param data.houseNumber The optional house number
 * @param data.addition Optional house number addition
 * @returns ValidatePostcodeResponse OK
 * @throws ApiError
 */
const getValidatePostalCodeV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/feh/postcode/v1',
        query: {
            postcode: data.postcode,
            house_number: data.houseNumber,
            addition: data.addition
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getValidatePostalCodeV1 = getValidatePostalCodeV1;
/**
 * Submit generic form data
 * @param data The data for the request.
 * @param data.requestBody
 * @returns FormSubmitResponse OK
 * @throws ApiError
 */
const postGenericFormSubmit = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/feh/generic/formsubmit/v3',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postGenericFormSubmit = postGenericFormSubmit;
/**
 * Calculate the payback period in years for a set of solar panels, based on the consumption of the household
 * @param data The data for the request.
 * @param data.kwh The KWh of consumption of the household
 * @returns CalculateSolarPanelPaybackResponse OK
 * @throws ApiError
 */
const getSolarpaybackV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/feh/solarpayback/v1',
        query: {
            kwh: data.kwh
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getSolarpaybackV1 = getSolarpaybackV1;
/**
 * Retrieve available days that has timeslots from suiteCRM
 * @param data The data for the request.
 * @param data.dateStart
 * @returns GetAvailableDaysResponseSchema OK
 * @throws ApiError
 */
const getDaysV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/feh/timeslots/days/v1',
        query: {
            date_start: data.dateStart
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getDaysV1 = getDaysV1;
/**
 * Retrieve available timeslots for a specific day from suiteCRM
 * @param data The data for the request.
 * @param data.dateStart
 * @returns GetAvailableTimesResponseSchema OK
 * @throws ApiError
 */
const getTimesV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/feh/timeslots/times/v1',
        query: {
            date_start: data.dateStart
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getTimesV1 = getTimesV1;
/**
 * Check the availability of a selected timeslot from suiteCRM
 * @param data The data for the request.
 * @param data.date The date to check for available time slots
 * @param data.id The unique identifier of the time slot to check
 * @returns CheckTimeSlotAvailabilityResponseSchema OK
 * @throws ApiError
 */
const getCheckV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/feh/timeslots/times/check/v1',
        query: {
            date: data.date,
            id: data.id
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getCheckV1 = getCheckV1;
/**
 * Create a new insulation lead
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
const postInsulationV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/feh/leads/insulation/v1',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postInsulationV1 = postInsulationV1;
/**
 * Create a new solar panel lead
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
const postSolarpanelV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/feh/leads/solar-panel/v1',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postSolarpanelV1 = postSolarpanelV1;
/**
 * Create a new house scan lead
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
const postHousescanV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/feh/leads/house-scan/v1',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postHousescanV1 = postHousescanV1;
/**
 * Validate a provided postcode and house number using the Cadastre API from Sustainables.
 * @param data The data for the request.
 * @param data.postcode Postcode in Dutch format
 * @param data.houseNumber The optional house number
 * @param data.addition Optional house number addition
 * @returns ValidatePostcodeResponse OK
 * @throws ApiError
 */
const getValidatePostalCodeHouseScanV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/feh/leads/house-scan/postcode/v1',
        query: {
            postcode: data.postcode,
            house_number: data.houseNumber,
            addition: data.addition
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getValidatePostalCodeHouseScanV1 = getValidatePostalCodeHouseScanV1;
/**
 * Create a new third party lead
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
const postThirdpartyV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/feh/leads/third-party/v1',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            409: '',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postThirdpartyV1 = postThirdpartyV1;
/**
 * Create a new advice lead
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
const postAdviceV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/feh/leads/advice/v1',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postAdviceV1 = postAdviceV1;
/**
 * Create a new product advice lead
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
const postProductadviceV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/feh/leads/product-advice/v1',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            409: '',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postProductadviceV1 = postProductadviceV1;
/**
 * Create a new home battery lead
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
const postHomebatteryV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/feh/leads/home-battery/v1',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postHomebatteryV1 = postHomebatteryV1;
/**
 * Create a new boiler lead
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
const postBoilerV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/feh/leads/boiler/v1',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postBoilerV1 = postBoilerV1;
/**
 * Create a new heat pump lead
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
const postHeatpumpV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/feh/leads/heat-pump/v1',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postHeatpumpV1 = postHeatpumpV1;
/**
 * Create a new SenO lead
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
const postSenoV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/feh/leads/seno/v1',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postSenoV1 = postSenoV1;
/**
 * Create a new Generic Non-Commodity lead
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
const postGenericnoncommodityV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/feh/leads/generic-non-commodity/v1',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postGenericnoncommodityV1 = postGenericnoncommodityV1;
/**
 * Retrieve additional(address/building) information for the insulation address check
 * @param data The data for the request.
 * @param data.postalcode
 * @param data.housenumber
 * @param data.buildingType
 * @param data.funnelsettingsId
 * @param data.housenumberaddition
 * @returns InsulationGetAddressInfoResponseSchema OK
 * @throws ApiError
 */
const getGetaddressinfoV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/feh/leads/insulation/get-address-info/v1',
        query: {
            postalcode: data.postalcode,
            housenumber: data.housenumber,
            housenumberaddition: data.housenumberaddition,
            building_type: data.buildingType,
            funnelsettings_id: data.funnelsettingsId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getGetaddressinfoV1 = getGetaddressinfoV1;
/**
 * Retrieve boiler products based on funnel settings
 * @param data The data for the request.
 * @param data.funnelSettingsId
 * @returns GetBoilerProductsResponseSchema OK
 * @throws ApiError
 */
const getBoilerProducts = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/feh/products/boiler/v1',
        query: {
            funnelSettingsId: data.funnelSettingsId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getBoilerProducts = getBoilerProducts;
/**
 * Retrieve additional(address/building) information for the solar panel address check
 * @param data The data for the request.
 * @param data.postalcode
 * @param data.housenumber
 * @param data.consumption
 * @param data.funnelsettingsId
 * @param data.housenumberaddition
 * @returns SolarGetAddressInfoResponseSchema OK
 * @throws ApiError
 */
const getAddressinfoV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/feh/leads/solar-panel/address-info/v1',
        query: {
            postalcode: data.postalcode,
            housenumber: data.housenumber,
            housenumberaddition: data.housenumberaddition,
            consumption: data.consumption,
            funnelsettings_id: data.funnelsettingsId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getAddressinfoV1 = getAddressinfoV1;
/**
 * Get presigned URL for document upload against emob's solution
 * @returns PresignedUrlApiResponse OK
 * @throws ApiError
 */
const getPresignV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/feh/docs/presign/v1',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getPresignV1 = getPresignV1;
/**
 * Send F contract emails
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
const postContractsV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/feh/emails/contracts/v1',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postContractsV1 = postContractsV1;
/**
 * Send service (SNO) emails
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
const postServiceV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/feh/emails/service/v1',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postServiceV1 = postServiceV1;
